import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/merchant",
  name: "/merchant",
  redirect: {
    name: "merchant",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/merchant/list",
      name: "merchantList",
      meta: {
        ...meta,
        title: "商事管理",
        cache: true,
      },
      component: () => import("@/pages/merchant/MerchantList.vue"),
    },
    {
      path: "/merchant/add",
      name: "merchantAdd",
      meta: {
        ...meta,
        title: "商事新增",
      },
      component: () => import("@/pages/merchant/MerchantAdd.vue"),
    },
  ],
};
